import { render, staticRenderFns } from "./AddDropRequest.vue?vue&type=template&id=487b7a70&scoped=true&"
import script from "./AddDropRequest.vue?vue&type=script&lang=js&"
export * from "./AddDropRequest.vue?vue&type=script&lang=js&"
import style0 from "./AddDropRequest.vue?vue&type=style&index=0&id=487b7a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b7a70",
  null
  
)

export default component.exports